import React, { useState, useEffect, useContext } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import api, { BASE_URL } from "../../Utils/api";
import Modal from "react-bootstrap/Modal";
import { GlobalContext } from "../../Utils/GlobalContext";
import { FaUserFriends } from "react-icons/fa";
import { Salvar, Cancelar, ErroModal } from "../Generals";
import { useFeedback } from "../Generals/Feedback/FeedbackContext";
import UsuariosNotificacaoModal from "./UsuariosNotificacaoModal";


const TiposAgendamentoModal = ({
  show,
  handleClose,
  agendamento,
  fetchTiposAgendamento,
}) => {
  const { toast } = useFeedback();
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [periodicidade, setPeriodicidade] = useState("D");
  const [diasAntecedencia, setDiasAntecedencia] = useState("");
  const [diasSemana, setDiasSemana] = useState("");
  const [diaMes, setDiaMes] = useState("");
  const [mesAno, setMesAno] = useState("");
  const [horario, setHorario] = useState("08:00");
  const [situacao, setSituacao] = useState("A");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showUsuariosModal, setShowUsuariosModal] = useState(false);

  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");
  
  // Array de dias da semana para checkboxes
  const diasDaSemana = [
    { id: 1, nome: "Domingo" },
    { id: 2, nome: "Segunda" },
    { id: 3, nome: "Terça" },
    { id: 4, nome: "Quarta" },
    { id: 5, nome: "Quinta" },
    { id: 6, nome: "Sexta" },
    { id: 7, nome: "Sábado" },
  ];

  // Array de meses para select
  const mesesDoAno = [
    { id: 1, nome: "Janeiro" },
    { id: 2, nome: "Fevereiro" },
    { id: 3, nome: "Março" },
    { id: 4, nome: "Abril" },
    { id: 5, nome: "Maio" },
    { id: 6, nome: "Junho" },
    { id: 7, nome: "Julho" },
    { id: 8, nome: "Agosto" },
    { id: 9, nome: "Setembro" },
    { id: 10, nome: "Outubro" },
    { id: 11, nome: "Novembro" },
    { id: 12, nome: "Dezembro" },
  ];

  useEffect(() => {
    if (!show) return;
    setError(null);
    if (agendamento) {
      setNome(agendamento.nome || "");
      setDescricao(agendamento.descricao || "");
      setPeriodicidade(agendamento.periodicidade || "D");
      setDiasAntecedencia(agendamento.dias_antecedencia || "");

      // Processamento dos dias da semana (caso seja uma string separada por vírgula)
      if (agendamento.dias_semana) {
        setDiasSemana(agendamento.dias_semana);
      } else {
        setDiasSemana("");
      }

      setDiaMes(agendamento.dia_mes || "");
      setMesAno(agendamento.mes_ano || "");

      // Tratar o horário do agendamento
      if (agendamento.horario) {
        const timeString = agendamento.horario.substring(0, 5);
        setHorario(timeString);
      } else {
        setHorario("08:00");
      }

      setSituacao(agendamento.situacao || "A");
    } else {
      resetForm();
    }
  }, [show, agendamento]);

  const resetForm = () => {
    setNome("");
    setDescricao("");
    setPeriodicidade("D");
    setDiasAntecedencia("");
    setDiasSemana("");
    setDiaMes("");
    setMesAno("");
    setHorario("08:00");
    setSituacao("A");
    setError(null);
  };

  const handleDiasSemanaChange = (diaId) => {
    const diasArray = diasSemana ? diasSemana.split(',').map(Number) : [];

    if (diasArray.includes(diaId)) {
      // Remove o dia se já estiver selecionado
      const novosDias = diasArray.filter(id => id !== diaId).join(',');
      setDiasSemana(novosDias);
    } else {
      // Adiciona o dia se não estiver selecionado
      const novosDias = [...diasArray, diaId].sort().join(',');
      setDiasSemana(novosDias);
    }
  };

  const isDiaSelecionado = (diaId) => {
    if (!diasSemana) return false;
    return diasSemana.split(',').map(Number).includes(diaId);
  };

  // Função para abrir o modal de seleção de usuários
  const handleOpenUsuariosModal = () => {
    if (!agendamento || !agendamento.id) {
      toast.warning("Você precisa salvar o tipo de agendamento antes de configurar os usuários de notificação.");
      return;
    }
    setShowUsuariosModal(true);
  };

  const handleSave = async () => {
    // Validação básica
    if (!nome.trim()) {
      setError("O nome do tipo de agendamento é obrigatório");
      return;
    }

    if (!periodicidade) {
      setError("A periodicidade é obrigatória");
      return;
    }

    if (!horario) {
      setError("O horário é obrigatório");
      return;
    }

    // Validações adicionais conforme a periodicidade
    if (periodicidade === "S" && !diasSemana) {
      setError("Para agendamentos semanais, selecione pelo menos um dia da semana");
      return;
    }

    if (periodicidade === "M" && !diaMes) {
      setError("Para agendamentos mensais, informe o dia do mês");
      return;
    }

    if (periodicidade === "A" && (!diaMes || !mesAno)) {
      setError("Para agendamentos anuais, informe o dia e o mês");
      return;
    }

    if (periodicidade === "V" && !diasAntecedencia) {
      setError("Para agendamentos por vencimento, informe os dias de antecedência");
      return;
    }

    // Formatação do horário para garantir o formato correto para o banco de dados
    const formattedHorario = horario.includes(':') ?
      (horario.length === 5 ? `${horario}:00` : horario) :
      `${horario}:00:00`;

    // Preparação dos dados para envio
    const agendamentoData = {
      nome,
      descricao,
      periodicidade,
      // Tratar dias_antecedencia de acordo com a periodicidade
      dias_antecedencia: (periodicidade === "V" || periodicidade === "D")
        ? (diasAntecedencia === "" ? null : parseInt(diasAntecedencia, 10))
        : null,
      dias_semana: periodicidade === "S" ? diasSemana : null,
      dia_mes: (periodicidade === "M" || periodicidade === "A") ? diaMes : null,
      mes_ano: periodicidade === "A" ? mesAno : null,
      horario: formattedHorario, // Enviar o horário formatado corretamente
      situacao
    };

    setLoading(true);
    setError(null);

    try {
      if (agendamento) {
        // Edição de agendamento existente
        await api.put(
          `${BASE_URL}/api/tiposAgendamentos/EditarTiposAgendamento/${agendamento.id}`,
          agendamentoData
        );
      } else {
        // Inserção de novo agendamento
        await api.post(
          `${BASE_URL}/api/tiposAgendamentos/InserirTiposAgendamento/${entidadeID}`,
          agendamentoData
        );
      }

      // Atualiza a lista e fecha o modal
      fetchTiposAgendamento();
      handleClose();
    } catch (err) {
      console.error("Erro ao salvar tipo de agendamento:", err);
      setError(
        err.response?.data?.message ||
        "Ocorreu um erro ao salvar o tipo de agendamento. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="lg" dialogClassName="modal-dialog-top">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          {agendamento ? "Tipo de Agendamento" : "Adicionar Tipo de Agendamento"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        <ErroModal erro={error} />

        <Form>
          <Row>
            <Col md={6}>
              <Form.Group controlId="formNome" className="mb-3">
                <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nome do agendamento"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formPeriodicidade" className="mb-3">
                <Form.Label>Periodicidade <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  value={periodicidade}
                  onChange={(e) => setPeriodicidade(e.target.value)}
                  required
                >
                  <option value="D">Diário</option>
                  <option value="S">Semanal</option>
                  <option value="M">Mensal</option>
                  <option value="A">Anual</option>
                  <option value="V">Dias Antes do Vencimento</option>
                  <option value="VD">Dias Antes do Vencimento (Pelo Documento)</option>
                  <option value="U">Único</option>
                </Form.Select>
                {periodicidade === "VD" && (
                  <Form.Text className="text-muted">
                    Utilizará o valor do campo "Dias de Aviso" configurado em cada documento.
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId="formDescricao" className="mb-3">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Descrição detalhada do agendamento"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group controlId="formHorario" className="mb-3">
                <Form.Label>Horário <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="time"
                  value={horario}
                  onChange={(e) => setHorario(e.target.value)}
                  required
                />
                <Form.Text className="text-muted">
                  Horário para execução do agendamento
                </Form.Text>
              </Form.Group>
            </Col>

            {/* Campo de Dias de Antecedência - Mostrado para "Dias Antes do Vencimento" e "Diário" */}
            {(periodicidade === "V" || periodicidade === "D") && (
              <Col md={6}>
                <Form.Group controlId="formDiasAntecedencia" className="mb-3">
                  <Form.Label>
                    Dias de Antecedência
                    {periodicidade === "V" && <span className="text-danger">*</span>}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Dias antes do vencimento"
                    value={diasAntecedencia}
                    onChange={(e) => setDiasAntecedencia(e.target.value)}
                    min="0"
                  />
                  <Form.Text className="text-muted">
                    {periodicidade === "V"
                      ? "Número de dias antes do vencimento para executar o agendamento"
                      : "Dias para notificação prévia (opcional)"}
                  </Form.Text>
                </Form.Group>
              </Col>
            )}
          </Row>

          {/* Campos específicos conforme a periodicidade */}
          {periodicidade === "S" && (
            <Form.Group controlId="formDiasSemana" className="mb-3">
              <Form.Label>Dias da Semana <span className="text-danger">*</span></Form.Label>
              <div className="d-flex flex-wrap">
                {diasDaSemana.map((dia) => (
                  <Form.Check
                    key={dia.id}
                    type="checkbox"
                    id={`dia-${dia.id}`}
                    label={dia.nome}
                    className="me-3 mb-2"
                    checked={isDiaSelecionado(dia.id)}
                    onChange={() => handleDiasSemanaChange(dia.id)}
                  />
                ))}
              </div>
            </Form.Group>
          )}

          {(periodicidade === "M" || periodicidade === "A") && (
            <Form.Group controlId="formDiaMes" className="mb-3">
              <Form.Label>Dia do Mês <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="number"
                placeholder="Dia do mês (1-31)"
                value={diaMes}
                onChange={(e) => setDiaMes(e.target.value)}
                min="1"
                max="31"
              />
            </Form.Group>
          )}

          {periodicidade === "A" && (
            <Form.Group controlId="formMesAno" className="mb-3">
              <Form.Label>Mês do Ano <span className="text-danger">*</span></Form.Label>
              <Form.Select
                value={mesAno}
                onChange={(e) => setMesAno(e.target.value)}
              >
                <option value="">Selecione um mês</option>
                {mesesDoAno.map((mes) => (
                  <option key={mes.id} value={mes.id}>
                    {mes.nome}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}

          <Form.Group controlId="formSituacao" className="mb-3">
            <Form.Label>Situação</Form.Label>
            <Form.Select
              value={situacao}
              onChange={(e) => setSituacao(e.target.value)}
            >
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda">
          {/* Visível também no cadastro (não só na edição) — se ainda não
              salvo, handleOpenUsuariosModal avisa que precisa salvar antes. */}
          <Button
            variant="light"
            size="sm"
            className="modal-footer-btn-acao btn-acao-notificacao"
            onClick={handleOpenUsuariosModal}
            title="Usuários para notificação"
          >
            <FaUserFriends size={18} className="me-1" /></Button>
        </div>
        <div className="modal-footer-acoes-direita">
          <Cancelar onClick={handleClose} disabled={loading} />
          <Salvar onClick={handleSave} loading={loading} />
        </div>
      </Modal.Footer>

      <UsuariosNotificacaoModal
        show={showUsuariosModal}
        handleClose={() => setShowUsuariosModal(false)}
        agendamentoId={agendamento?.id}
      />
    </Modal>
  );
};

export default TiposAgendamentoModal;